import { TRANSFERS } from "../actions/types";
import { takeLatest, takeEvery, call, put } from "redux-saga/effects";
import { resolveBankSuccess } from "../actions/Transfers";
import { loadingFinish } from "../actions/Loading";
import { updateProfile } from "../actions/Settings";
import { accLoadingFinish } from "../actions/accLoading";

import axios from "axios";
import { toast } from "react-toastify";
import { logout } from "../actions/Auth";
import history from "../../helpers/history";
const API_BASE = `${process.env.REACT_APP_API_BASE_URL}agent`;

function* handleAgentTransfer({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/wallet/fund/transfer/internal`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      yield put(updateProfile());
      sessionStorage.setItem("message", result.data.message);
      sessionStorage.setItem("disable", true);
      const date = new Date();
      const today = `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth()
      ).padStart(2, "0")}-${date.getFullYear()}`;
      const time = `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
      sessionStorage.setItem(
        "date",
        JSON.stringify({ time, today, description: "Debit From Wallet" })
      );
      history.push("/agent/transfers/success");
    } else {
      let errorMessage = result.data.message;
      toast.error(errorMessage);
      throw errorMessage;
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    // sessionStorage.removeItem("agent-transfers");
    yield put(loadingFinish());
  }
}

function* handleResolveAccount({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/resolve/bank/account`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...payload,
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "error")
      toast.error("No bank acoount with such details");
    if (result.data.status === "success") {
      if (
        result.data.bank_account_name === "ERROR" ||
        result.data.status === false
      ) {
        toast.error("No bank acoount with such details");
        yield put(resolveBankSuccess(""));
      } else {
        yield put(resolveBankSuccess(result.data.bank_account_name));
      }
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
    yield put(resolveBankSuccess(""));
  } finally {
    yield put(accLoadingFinish());
  }
}

function* handleBankTransfer({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/wallet/fund/bank/transfer`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      yield put(updateProfile());
      sessionStorage.setItem("message", result.data.message);
      sessionStorage.setItem("disable", true);
      const date = new Date();
      const today = `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth()
      ).padStart(2, "0")}-${date.getFullYear()}`;
      const time = `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
      sessionStorage.setItem(
        "date",
        JSON.stringify({ time, today, description: "Bank Transfer" })
      );
      history.push("/agent/transfers/success");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    // sessionStorage.removeItem("bank-transfers");
    yield put(loadingFinish());
  }
}

const transfersSaga = [
  takeLatest(TRANSFERS.AGENT, handleAgentTransfer),
  takeEvery(TRANSFERS.RESOLVE_ACCOUNT_NUMBER, handleResolveAccount),
  takeLatest(TRANSFERS.BANK_TRANSFER, handleBankTransfer),
];

export default transfersSaga;
